import {BaseIntDTO} from "../_baseIntDTO.interface";

export interface VehicleColourDTO extends BaseIntDTO {
  colourName: string;
}
